import { Package, CheckCircle, DollarSign, MapPin, List, TrendingUp, User, Bell, Search, MessageCircle } from "lucide-react";
import { motion } from "framer-motion";
import { useCourierLanguage } from "../contexts/CourierLanguageContext";
import { useState, useEffect } from "react";
import axios from "axios";
import cacheStorage from "../../../utils/cacheStorage";
import { useNotifications } from "../CourierApp";
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";

export function CourierDashboard({
                                   navigateTo
                                 }) {
  const {
    t,
    data
  } = useCourierLanguage();
  const {
    hasUnread
  } = useNotifications();
  const [searchQuery, setSearchQuery] = useState("");
  const [deliveries, setDeliveries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDeliveries = async () => {
      try {
        setLoading(true);
        const token = cacheStorage.getItem('access_token');
        const response = await axios.get('https://smart-cargo-backend-923182991420.us-central1.run.app/api/courier/deliveries', {
          headers: token ? {
            'Authorization': `Bearer ${token}`
          } : {}
        });

        const dbData = response.data;
        if (dbData) {
          const validData = dbData.filter(pkg => pkg.lat != null && pkg.lng != null && pkg.lat !== 0 && pkg.lng !== 0);
          setDeliveries(validData);
        }
      } catch (error) {
        console.error("Error fetching:", error);
        setDeliveries([]);
      } finally {
        setLoading(false);
      }
    };

    fetchDeliveries();
  }, []);

  const currentHour = new Date().getHours();
  const greeting = currentHour < 12 ? t.goodMorning : currentHour < 18 ? t.goodAfternoon : t.goodEvening;

  const stats = [{
    label: t.assignedToday,
    value: "8",
    icon: Package,
    color: "#2D58AD"
  }, {
    label: t.completed,
    value: "5",
    icon: CheckCircle,
    color: "#10B981"
  }, {
    label: t.todaysEarnings,
    value: "₼124",
    icon: DollarSign,
    color: "#F59E0B"
  }];

  // const upcomingDeliveries = deliveries.slice(0, 3).map((pkg, index) => ({
  //   id: `SHP-${pkg.id}`,
  //   address: (typeof pkg.delivery_address === 'object' ? pkg.delivery_address?.String : pkg.delivery_address) || pkg.destination || "Unknown Address",
  //   customer: (typeof pkg.customer_name === 'object' ? pkg.customer_name?.String : pkg.customer_name) || "Unknown Customer",
  //   eta: pkg.status === 'In Transit' ? "1 hour" : "30 mins",
  //   status: pkg.status
  // }));

  return /*#__PURE__*/_jsxs("div", {
    className: "min-h-screen bg---F5F6FA-",
    children: [/*#__PURE__*/_jsxs("div", {
      className: "bg-gradient-to-r from---2D58AD- to---71A4F4- text-white p-6 pb-24",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "flex items-center justify-between mb-6",
        children: [/*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsxs("h1", {
            className: "text-2xl font-bold",
            children: [greeting, ", ", data.courierName || "Courier"]
          }), /*#__PURE__*/_jsx("p", {
            className: "text-white-80 text-sm mt-1",
            children: "M\xFCk\u0259mm\u0259l \xE7atd\u0131r\u0131lma \xFC\xE7\xFCn haz\u0131r"
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "flex items-center gap-2",
          children: [/*#__PURE__*/_jsxs("button", {
            onClick: () => navigateTo("notifications"),
            className: "w-12 h-12 rounded-full bg-white-20 backdrop-blur-sm flex items-center justify-center hover-bg-white-30 transition-colors relative",
            children: [/*#__PURE__*/_jsx(Bell, {
              className: "w-6 h-6"
            }), hasUnread && /*#__PURE__*/_jsx("span", {
              className: "absolute top-2 right-2 w-2-5 h-2-5 bg-red-500 rounded-full"
            })]
          }), /*#__PURE__*/_jsx("button", {
            onClick: () => navigateTo("profile"),
            className: "w-12 h-12 rounded-full bg-white-20 backdrop-blur-sm flex items-center justify-center hover-bg-white-30 transition-colors",
            children: /*#__PURE__*/_jsx(User, {
              className: "w-6 h-6"
            })
          })]
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "relative",
        children: [/*#__PURE__*/_jsx(Search, {
          className: "absolute left-4 top-1-2 neg-translate-y-1-2 w-5 h-5 text-white-60"
        }), /*#__PURE__*/_jsx("input", {
          type: "text",
          value: searchQuery,
          onChange: e => setSearchQuery(e.target.value),
          placeholder: t.searchGlobal,
          className: "w-full pl-12 pr-4 py-3 bg-white-20 backdrop-blur-sm rounded-xl text-white placeholder-text-white-60 focus-outline-none focus-ring-2 focus-ring-white-50 transition-all"
        })]
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: "px-4 neg-mt-16 pb-24",
      children: [/*#__PURE__*/_jsx("div", {
        className: "grid grid-cols-3 gap-3 mb-6",
        children: stats.map((stat, index) => /*#__PURE__*/_jsxs(motion.div, {
          initial: {
            opacity: 0,
            y: 20
          },
          animate: {
            opacity: 1,
            y: 0
          },
          transition: {
            delay: index * 0.1
          },
          className: "bg-white rounded-2xl p-4 shadow-md",
          children: [/*#__PURE__*/_jsx("div", {
            className: "w-10 h-10 rounded-xl flex items-center justify-center mb-3",
            style: {
              backgroundColor: `${stat.color}20`
            },
            children: /*#__PURE__*/_jsx(stat.icon, {
              className: "w-5 h-5",
              style: {
                color: stat.color
              }
            })
          }), /*#__PURE__*/_jsx("p", {
            className: "text-2xl font-bold text---000080-",
            children: stat.value
          }), /*#__PURE__*/_jsx("p", {
            className: "text-xs text-neg-708094- mt-1",
            children: stat.label
          })]
        }, stat.label))
      }), /*#__PURE__*/_jsxs(motion.button, {
        initial: {
          opacity: 0,
          scale: 0.95
        },
        animate: {
          opacity: 1,
          scale: 1
        },
        transition: {
          delay: 0.3
        },
        onClick: () => navigateTo("route"),
        className: "w-full p-5 rounded-2xl font-bold text-lg flex items-center justify-center gap-3 transition-all shadow-sm hover-shadow-md bg-neg-2D58AD- text-white mb-6",
        children: [/*#__PURE__*/_jsx(MapPin, {
          className: "w-6 h-6"
        }), /*#__PURE__*/_jsx("span", {
          children: t.startRoute
        })]
      }), /*#__PURE__*/_jsx(motion.div, {
        initial: {
          opacity: 0,
          y: 20
        },
        animate: {
          opacity: 1,
          y: 0
        },
        transition: {
          delay: 0.4
        },
        className: "bg-white rounded-2xl overflow-hidden shadow-md mb-6",
        children: /*#__PURE__*/_jsxs("div", {
          className: "h-48 bg-gradient-to-br from---DEEAFC- to---71A4F4--20 relative flex items-center justify-center",
          children: [/*#__PURE__*/_jsx(MapPin, {
            className: "w-16 h-16 text-neg-2D58AD--30"
          }), /*#__PURE__*/_jsx("div", {
            className: "absolute bottom-4 left-4 right-4",
            children: /*#__PURE__*/_jsx("div", {
              className: "bg-white rounded-xl p-3 shadow-lg flex items-center justify-between",
              children: /*#__PURE__*/_jsxs("div", {
                children: [/*#__PURE__*/_jsx("p", {
                  className: "text-sm font-semibold text---000080-",
                  children: "Mar\u015Frutunuz haz\u0131rd\u0131r"
                }), /*#__PURE__*/_jsxs("p", {
                  className: "text-xs text-neg-708094- mt-1 flex items-center gap-2",
                  children: [/*#__PURE__*/_jsx("span", {
                    children: "3 \xE7atd\u0131r\u0131lma qal\u0131r"
                  }), /*#__PURE__*/_jsx("span", {
                    children: "\u2022"
                  }), /*#__PURE__*/_jsx("span", {
                    children: "4.2 km"
                  })]
                })]
              })
            })
          })]
        })
      }), /*#__PURE__*/_jsxs(motion.div, {
        initial: {
          opacity: 0,
          y: 20
        },
        animate: {
          opacity: 1,
          y: 0
        },
        transition: {
          delay: 0.6
        },
        // children: [/*#__PURE__*/_jsxs("div", {
        //   className: "flex items-center justify-between mb-4",
        //   children: [/*#__PURE__*/_jsx("h2", {
        //     className: "text-lg font-bold text---000080-",
        //     children: t.upcomingDeliveries
        //   }), /*#__PURE__*/_jsx("button", {
        //     onClick: () => navigateTo("packages"),
        //     className: "text-sm text-neg-2D58AD- font-medium",
        //     children: t.viewAll
        //   })]
        // })
          // , /*#__PURE__*/_jsx("div", {
          // className: "space-y-3",
          // children: loading ? /*#__PURE__*/_jsx("div", {
          //   className: "text-center py-8",
          //   children: /*#__PURE__*/_jsx("p", {
          //     className: "text-neg-708094-",
          //     children: "Loading..."
          //   })
          // }) : upcomingDeliveries.length > 0 ? upcomingDeliveries.map((delivery, index) => /*#__PURE__*/_jsxs(motion.div, {
          //   initial: {
          //     opacity: 0,
          //     x: -20
          //   },
          //   animate: {
          //     opacity: 1,
          //     x: 0
          //   },
          //   transition: {
          //     delay: 0.7 + index * 0.1
          //   },
          //   onClick: () => navigateTo("package-detail", delivery.id),
          //   className: "bg-white rounded-xl p-4 shadow-sm hover-shadow-md transition-shadow cursor-pointer",
          //   children: [/*#__PURE__*/_jsxs("div", {
          //     className: "flex items-start justify-between mb-2",
          //     children: [/*#__PURE__*/_jsxs("div", {
          //       children: [/*#__PURE__*/_jsx("p", {
          //         className: "font-semibold text---000080-",
          //         children: delivery.id
          //       }), /*#__PURE__*/_jsx("p", {
          //         className: "text-sm text-neg-708094- mt-1",
          //         children: delivery.customer
          //       })]
          //     }), /*#__PURE__*/_jsx("span", {
          //       className: "px-3 py-1 bg-neg-2D58AD--10 text-neg-2D58AD- text-xs font-medium rounded-full",
          //       children: delivery.eta
          //     })]
          //   }), /*#__PURE__*/_jsxs("div", {
          //     className: "flex items-center gap-2 text-sm text-neg-708094-",
          //     children: [/*#__PURE__*/_jsx(MapPin, {
          //       className: "w-4 h-4"
          //     }), /*#__PURE__*/_jsx("span", {
          //       children: delivery.address
          //     })]
          //   })]
          // }
          // , delivery.id)) : /*#__PURE__*/_jsxs("div", {
          //   className: "text-center py-8 bg-white rounded-xl border border-dashed border-gray-200",
          //   children: [/*#__PURE__*/_jsx(Package, {
          //     className: "w-10 h-10 text-neg-708094- mx-auto mb-2 opacity-50"
          //   }), /*#__PURE__*/_jsx("p", {
          //     className: "text-neg-708094- font-medium",
          //     children: t.noPackagesFound || "No active deliveries"
          //   })]
          // })
        // })]
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 px-4 py-3 safe-area-bottom",
      children: /*#__PURE__*/_jsxs("div", {
        className: "flex items-center justify-around max-w-md mx-auto",
        children: [/*#__PURE__*/_jsxs("button", {
          onClick: () => navigateTo("dashboard"),
          className: "flex flex-col items-center gap-1 text-neg-2D58AD-",
          children: [/*#__PURE__*/_jsx(Package, {
            className: "w-6 h-6"
          }), /*#__PURE__*/_jsx("span", {
            className: "text-xs font-medium",
            children: t.home
          })]
        }), /*#__PURE__*/_jsxs("button", {
          onClick: () => navigateTo("packages"),
          className: "flex flex-col items-center gap-1 text-neg-708094-",
          children: [/*#__PURE__*/_jsx(List, {
            className: "w-6 h-6"
          }), /*#__PURE__*/_jsx("span", {
            className: "text-xs font-medium",
            children: t.packages
          })]
        }), /*#__PURE__*/_jsxs("button", {
          onClick: () => navigateTo("messages"),
          className: "flex flex-col items-center gap-1 text-neg-708094-",
          children: [/*#__PURE__*/_jsx(MessageCircle, {
            className: "w-6 h-6"
          }), /*#__PURE__*/_jsx("span", {
            className: "text-xs font-medium",
            children: "Messages"
          })]
        }), /*#__PURE__*/_jsxs("button", {
          onClick: () => navigateTo("performance"),
          className: "flex flex-col items-center gap-1 text-neg-708094-",
          children: [/*#__PURE__*/_jsx(TrendingUp, {
            className: "w-6 h-6"
          }), /*#__PURE__*/_jsx("span", {
            className: "text-xs font-medium",
            children: t.performance
          })]
        }), /*#__PURE__*/_jsxs("button", {
          onClick: () => navigateTo("profile"),
          className: "flex flex-col items-center gap-1 text-neg-708094-",
          children: [/*#__PURE__*/_jsx(User, {
            className: "w-6 h-6"
          }), /*#__PURE__*/_jsx("span", {
            className: "text-xs font-medium",
            children: t.profile
          })]
        })]
      })
    })]
  });
}